export const validateRatingAnswer = (value, maxValue, minValue) => {
  return value >= minValue && value <= maxValue;
};

export const validateBinaryAnswer = (value, allowedValues) => {
  return allowedValues.includes(value);
};
